import React from 'react';

const SIZE_CLASSES = {
  small: 'h-4 w-4 border-2',
  default: 'h-8 w-8 border-4',
};

// Mapa explícito (não template string) — necessário pro Tailwind JIT detectar a classe. Ver docs/design-system/tokens.md
const BORDER_T_BY_MODULE = {
  finance: 'border-t-module-finance',
  travel: 'border-t-module-travel',
  planner: 'border-t-module-planner',
  health: 'border-t-module-health',
  notepad: 'border-t-module-notepad',
  identity: 'border-t-module-identity',
};

/**
 * Spinner de loading compartilhado. Antes duplicado em finance/travel/planner/notepad
 * com cor hardcoded por módulo — ver docs/design-system/decisions.md #002.
 */
const SpinnerLoad = ({ size = 'default', moduleKey }) => (
  <div className="flex justify-center items-center">
    <div
      className={`animate-spin rounded-full border-gray-300 ${SIZE_CLASSES[size] || SIZE_CLASSES.default} ${
        BORDER_T_BY_MODULE[moduleKey] || 'border-t-gray-700'
      }`}
    />
  </div>
);

export default SpinnerLoad;
